import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index";
import moment from 'moment';

export default {
    data() {
        return {
            changeValue: '',
            StartStopOption: {},
            workOption: {},
            faultOption: {},
            StartStopOptionLoading: false,
            workOptionLoading: false,
            faultOptionLoading: false,
            orgId: '',
            isValue: true,
            isShow: true,
            isDisplay: true,
            formInline: {
                selectCarType: '',
                selectCarValue: '',
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('VehicleAnalysis.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            height: '500',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('VehicleAnalysis.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                },
                {
                    prop: "stopCount",
                    label: this.$t('VehicleAnalysis.startStopTime'),
                    align: "center",
                },
                {
                    prop: "stopCountH",
                    label: this.$t('VehicleAnalysis.stopCountH'),
                    align: "center",
                },
                {
                    prop: "workTime",
                    label: this.$t('DriverAnalysis.workTime'),
                    align: "center",
                },
                {
                    prop: "workTimeH",
                    label: this.$t('VehicleAnalysis.workTimeH'),
                    align: "center",
                },
                {
                    prop: "problemCount",
                    label: this.$t('VehicleAnalysis.faultFrequency'),
                    align: "center",
                },
                {
                    prop: "problemCountH",
                    label: this.$t('VehicleAnalysis.problemCountH'),
                    align: "center",
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    created() {
        this.getDate()
    },
    methods: {
        getChangeFault() {
            this.faultOptionLoading = true
            let cars = [];
            let FaultCount = [];
            const startTime = this.changeValue[0]
            const endTime = this.changeValue[1]
            let param = {
                orgId: this.orgId,
                pageNum: 1,
                pageSize: 10,
                selectType: 2,
                selectTimeType: 4,
                startTime: startTime,
                endTime: endTime
            }
            this.$store.dispatch("VehicleAnalysis/GET_CARRANKORDER", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        if (res.data.data.length > 0) {
                            this.isValue = true
                            res.data.data.map((item, index) => {
                                cars.push(`${index + 1}.` + this.$t('common.carId') + `:${item.carId}`)
                                FaultCount.push(item.problemCount)
                                this.rankFault(cars, FaultCount)
                            })
                        } else {
                            this.isValue = false
                        }

                    }
                }
                this.faultOptionLoading = false
            }).catch(err => {
                this.faultOptionLoading = false
            })
        },
        rankFault(cars, FaultCount) {
            let option = {
                grid: {
                    left: '0',
                    right: '10%',
                    top: '10%',
                    bottom: '1%',
                    containLabel: true
                },
                xAxis: {
                    show: false,
                },
                yAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    data: cars.slice(0, 10).reverse()
                },
                series: [{
                    data: FaultCount.slice(0, 10).reverse(),
                    type: 'bar',
                    barCategoryGap: '50%',
                    label: {
                        normal: {
                            show: true,
                            position: 'right',
                            color: '#fff'
                        }
                    },
                    itemStyle: {
                        normal: {
                            barBorderRadius: 15,
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 0,
                                [
                                    { offset: 0, color: '#fc5a62' },
                                    { offset: 1, color: '#f69d70' },
                                ]
                            )
                        },
                    }
                }]
            }
            this.faultOption = option
        },

        getChangeWork() {
            this.workOptionLoading = true
            let carList = [];
            let workTime = [];
            const startTime = this.changeValue[0]
            const endTime = this.changeValue[1]
            let param = {
                orgId: this.orgId,
                pageNum: 1,
                pageSize: 10,
                selectType: 3,
                selectTimeType: 4,
                startTime: startTime,
                endTime: endTime
            }
            this.$store.dispatch("VehicleAnalysis/GET_CARRANKORDER", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        if (res.data.data.length > 0) {
                            this.isShow = true
                            res.data.data.map((item, index) => {
                                carList.push(`${index + 1}.` + this.$t('common.carId') + `:${item.carId}`)
                                workTime.push(item.workTime)
                                this.rankWork(carList, workTime)
                            })
                        } else {
                            this.isShow = false
                        }
                    }
                }
                this.workOptionLoading = false
            }).catch(err => {
                this.workOptionLoading = false
            })
        },
        rankWork(carList, workTime) {
            let option = {
                grid: {
                    left: '0',
                    right: '10%',
                    top: '10%',
                    bottom: '1%',
                    containLabel: true
                },
                xAxis: {
                    show: false,
                },
                yAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    data: carList.slice(0, 10).reverse()
                },
                series: [{
                    data: workTime.slice(0, 10).reverse(),
                    type: 'bar',
                    barCategoryGap: '50%',
                    label: {
                        normal: {
                            show: true,
                            position: 'right',
                            color: '#fff'
                        }
                    },
                    itemStyle: {
                        normal: {
                            barBorderRadius: 15,
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 0,
                                [
                                    { offset: 0, color: '#8e70f9' },
                                    { offset: 1, color: '#da609f' },
                                ]
                            )
                        },
                    }
                }]
            }
            this.workOption = option
        },

        getChangeRankStop() {
            this.StartStopOptionLoading = true
            let Car = [];
            let StartStop = [];
            const startTime = this.changeValue[0]
            const endTime = this.changeValue[1]
            let param = {
                orgId: this.orgId,
                pageNum: 1,
                pageSize: 10,
                selectType: 1,
                selectTimeType: 4,
                startTime: startTime,
                endTime: endTime
            };
            this.$store.dispatch("VehicleAnalysis/GET_CARRANKORDER", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        if (res.data.data.length > 0) {
                            this.isDisplay = true
                            res.data.data.map((item, index) => {
                                Car.push(`${index + 1}.` + this.$t('common.carId') + `:${item.carId}`)
                                StartStop.push(item.stopCount)
                                this.RankStopCount(Car, StartStop)
                            })
                        } else {
                            this.isDisplay = false
                        }
                    }
                }
                this.StartStopOptionLoading = false
            }).catch(err => {
                this.StartStopOptionLoading = false
            })
        },
        RankStopCount(Car, StartStop) {
            let option = {
                grid: {
                    left: '1%',
                    right: '10%',
                    top: '10%',
                    bottom: '1%',
                    containLabel: true
                },
                xAxis: {
                    show: false,
                },
                yAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    data: Car.slice(0, 10).reverse()
                },
                series: [{
                    data: StartStop.slice(0, 10).reverse(),
                    type: 'bar',
                    barCategoryGap: '50%',
                    label: {
                        normal: {
                            show: true,
                            position: 'right',
                            color: '#fff'
                        }
                    },
                    itemStyle: {
                        normal: {
                            barBorderRadius: 15,
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 1, 0,
                                [
                                    { offset: 0, color: '#437cfc' },
                                    { offset: 1, color: '#48e2f9' },
                                ]
                            )
                        },
                    }
                }]
            }
            this.StartStopOption = option
        },

        getDate() {
            const endTime = moment().subtract(1, "day").format("YYYY-MM-DD");
            const startTime = moment().subtract(1, "month").format("YYYY-MM-DD");
            this.changeValue = [startTime, endTime];
        },

        changeTime() {
            this.getChangeRankStop()
            this.getChangeWork()
            this.getChangeFault()
            this.getChangeOrderList()
        },

        getChangeOrderList() {
            const startTime = this.changeValue[0]
            const endTime = this.changeValue[1]
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectTimeType: 4,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                startTime: startTime,
                endTime: endTime
            };
            this.$store.dispatch('VehicleAnalysis/GET_CARORDERLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getChangeOrderList()
        },
        onClear() {
            this.formInline.selectCarType = ''
            this.formInline.selectCarValue = ''
            this.getChangeOrderList()
        },

        downCar() {
            if (domainName) {
                const startTime = this.changeValue[0]
                const endTime = this.changeValue[1]
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}//v1/getExportExcel/exportCarOrderList?orgId=${this.orgId}&selectTimeType=${4}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}//v1/getExportExcel/exportCarOrderList?orgId=${this.orgId}&selectTimeType=${4}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                }
            }
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getChangeOrderList();
        },
    }
}
